import React, { useState } from 'react';
import { Prompt, useLocation } from 'react-router-dom';
import PageLeaveConfirmationDialog from './PageLeaveConfirmationDialog';
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import { useEffect } from 'react';

type Props = {
    when: boolean,
    text: string,
    shouldBlockNavigation: (nextLocation: string) => boolean,
    navigate: (location: string) => void,
    checkFullLocation?: boolean
}

const RouteLeavingGuard : React.FC<Props> = ({when, text, shouldBlockNavigation, navigate, checkFullLocation = false}) => {

    const [confirmedNavigation, setConfirmedNavigation] = useStateWithCallbackLazy<boolean>(false);
    const [dialogVisible, setDialogVisible] = useStateWithCallbackLazy<boolean>(false);
    const [lastLocation, setLastLocation] = useState<string | null>(null);
    const location = useLocation();
    
    const handleBlockedNavigation = (nextLocation: any) : (string | boolean) => {
        if (!checkFullLocation) {
            if (nextLocation && nextLocation.pathname === location.pathname) {
                return true;
            }
        }
        if (!confirmedNavigation && shouldBlockNavigation(nextLocation)) {
            setDialogVisible(true, () => {});
            setLastLocation(nextLocation);
            return false;
        }
        return true;
    }

    useEffect(() => {
        setConfirmedNavigation(false, () => {

        });
    }, [location, setConfirmedNavigation])

    return (
        <>
            <PageLeaveConfirmationDialog
                open={dialogVisible}
                text={text}
                onCancel={() => {
                    setDialogVisible(false, () => {});
                }}
                onConfirm={() => {
                    setDialogVisible(false, () => {
                        if (lastLocation != null) {
                            setConfirmedNavigation(true, () => {
                                navigate(lastLocation);
                            });
                        }
                    });
                }}
            />
            <Prompt
                when={when}
                message={handleBlockedNavigation} />
        </>
    )
}

export default RouteLeavingGuard;